import React from "react";
import { WarningCircle } from "@phosphor-icons/react";

export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    window._factlifyLastError = { error, stack: info?.componentStack };
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-paper flex items-center justify-center p-8">
        <div className="text-center space-y-4 max-w-sm">
          <WarningCircle size={48} weight="bold" className="mx-auto text-red-500" />
          <p className="font-display font-black text-xl uppercase tracking-tight">Algo ha ido mal</p>
          <p className="text-sm text-ink/60">Esta página ha encontrado un error inesperado.</p>
          <button
            type="button"
            onClick={() => {
              this.setState({ hasError: false });
              window.location.href = "/dashboard";
            }}
            className="border-2 border-ink px-5 py-2.5 font-bold text-sm uppercase tracking-widest hover:bg-ink hover:text-white"
          >
            Volver al inicio
          </button>
        </div>
      </div>
    );
  }
}
